
    import { defineComponent, watch } from 'vue';
    import { SnackbarType } from '@/util/snack-bar';

    export default defineComponent({
        data() {
            return {
                snackBar: false,
                snackBarText: '',
                snackBarTimeout: 5000,
                snackBarColor: 'info'
            };
        },
        methods: {
            syncSnackbar() {
                const { isOpen, message, timeout, color } = this.$snackbar as SnackbarType;
                this.snackBar = isOpen.value;
                this.snackBarText = message.value;
                this.snackBarTimeout = timeout.value;
                this.snackBarColor = color.value;

                watch(isOpen, (newVal) => {
                    this.snackBar = newVal;
                });

                watch(message, (newVal) => {
                    this.snackBarText = newVal;
                });

                watch(timeout, (newVal) => {
                    this.snackBarTimeout = newVal;
                });

                watch(color, (newVal) => {
                    this.snackBarColor = newVal;
                });
            },

            updateSnackBarModelValue(value: boolean) {
                this.snackBar = value;
                if (!value) {
                    this.$snackbar.close();
                }
            },

            closeSnackBar() {
                this.$snackbar.close();
            },
        },
        created() {
            this.syncSnackbar();
        }
    });
